module.exports = __webpack_public_path__ + "static/media/bg-pattern-intro-right-desktop.fc61cf1f.svg";